export type Treatment = {
  name: string;
  category: 'weight-loss' | 'sexual-health';
  eyebrow: string;
  detail: string;
  description: string;
  included: string[];
  image: string;
  alt: string;
  tone: 'lime' | 'sky' | 'navy' | 'sand';
};

export const treatments: Treatment[] = [
  {
    name: 'Semaglutide',
    category: 'weight-loss',
    eyebrow: 'GLP-1 prescription option',
    detail: 'Weight loss care',
    description: 'A provider-reviewed option that may support weight management for eligible patients.',
    included: ['Online health assessment', 'Provider review', 'Ongoing check-ins'],
    image: '/images/treatment-semaglutide.jpg',
    alt: 'A considered still life representing semaglutide care',
    tone: 'lime',
  },
  {
    name: 'Tirzepatide',
    category: 'weight-loss',
    eyebrow: 'GLP-1 prescription option',
    detail: 'Weight loss care',
    description: 'A provider-reviewed option that may be appropriate for some weight management goals.',
    included: ['Online health assessment', 'Provider review', 'Ongoing check-ins'],
    image: '/images/treatment-tirzepatide.jpg',
    alt: 'A considered still life representing tirzepatide care',
    tone: 'sky',
  },
];

export const edTreatments: Treatment[] = [
  {
    name: 'ED care',
    category: 'sexual-health',
    eyebrow: 'Private care pathway',
    detail: 'Sexual health',
    description: 'Private online evaluation for adults exploring treatment options for erectile dysfunction.',
    included: ['Private health assessment', 'Provider review', 'Discreet delivery when prescribed'],
    image: '/images/treatment-ed-care.jpg',
    alt: 'An understated still life representing private ED care',
    tone: 'sand',
  },
  {
    name: 'A plan that fits',
    category: 'sexual-health',
    eyebrow: 'Ongoing support',
    detail: 'Sexual health',
    description: 'Start with your health history and goals, then review next steps with a licensed provider.',
    included: ['Private health assessment', 'Provider review', 'Ongoing support'],
    image: '/images/treatment-ed-support.jpg',
    alt: 'A quiet home scene representing ongoing ED care support',
    tone: 'navy',
  },
];
